module.exports = __webpack_public_path__ + "assets/images/help-center@3x-9ecbf3ca44e12227b827518b001986b6.jpg";